
import bild1977 from '@/assets/icons/zeit_1977.svg';
import bild1978 from '@/assets/icons/zeit_1978-2001.svg';
import bild2002 from '@/assets/icons/zeit_2002-2019.svg';
import bild2021 from '@/assets/icons/zeit_2021.svg';

export const buildingYearThresholds = {
    MONUMENT: 2002, // Baujahr < 2002
    RENOVATION: 2020, // Baujahr < 2020
    NOT_AVAILABLE: 2021 // Baujahr >= 2020
}
export const buildingAges = [
    { name: '1977 oder früher', available: true, value: '1977', api: '22467', image: bild1977 },
    { name: '1978 - 2001', available: true, value: '1978', api: '22468',  image: bild1978 },
    { name: '2002 - 2020', available: true, value: '2002', api: '22469', image: bild2002 },
    { name: '2021 oder später', available: false,  value: '2020', api: '20470', image: bild2021 },
];

export const buildingAgesApi = {parameter: '19379', type: 'value_choice'}